// extracted by mini-css-extract-plugin
module.exports = {"links":"BurgerMenu_links__2QVZG","menuItem":"BurgerMenu_menuItem__1muAt","active":"BurgerMenu_active__1vCXc"};